<template>
  <div class="authorization-form">
    <tab-simple v-model:value="currentTab" :items="authorizationTabs" />

    <authorization-controller :type="tabType" :options="countryDetails" :country-origin="countryOrigin" />
  </div>
</template>

<script setup lang="ts">
  import { AuthorizationTab } from '@skeleton/stores/useAuthorizationStore';

  const authorizationStore = useAuthorizationStore();
  const { setAuthorizationTab } = authorizationStore;
  const { currentAuthorizationTab, countryOrigin, countryDetails, authorizationTabs } = storeToRefs(authorizationStore);

  const currentTab = computed({
    get: () => currentAuthorizationTab.value,
    set: val => setAuthorizationTab(val),
  });

  const tabType = computed(() => (currentTab.value === AuthorizationTab.LOGIN ? 'login' : 'registration'));
</script>

<style src="~/assets/styles/components/authorization/form.scss" lang="scss" />
